var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import NavigationCard from '@/components/NavigationCard.vue';
import { Group } from '@/models/Group';
import { TabsColorEnum } from '@/config/theme';
let FavoriteGroupItems = class FavoriteGroupItems extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.$store.state.Auth;
    }
    get tabs() {
        return [
            {
                description: 'string',
                icon: 'home',
                is_visible: false,
                label: 'HOME',
                to: `/groups/${this.group ? this.group.id : ''}`,
                slug: 'home',
            },
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: `${this.$tc('navigationCard.group.profile')}`,
                icon: 'face',
                is_visible: this.favouriteTabs.includes('profile'),
                label: this.$tc('navigationCard.group.titles.profile'),
                to: `/groups/${this.group ? this.group.id : ''}/profile`,
                slug: 'profile',
            },
            {
                color: TabsColorEnum.BLACK,
                description: `${this.$tc('On this page you can quickly perform actions for one student, multiple students or the entire group.')}`,
                icon: 'settings',
                is_visible: this.favouriteTabs.includes('actions'),
                label: this.$tc('Actions'),
                to: `/groups/${this.group ? this.group.id : ''}/actions`,
                slug: 'actions',
            },
            {
                color: TabsColorEnum.LIGHT_ORANGE,
                description: `${this.$tc('On this page you find an overview of all the students in the group.')}`,
                icon: 'people',
                is_visible: this.favouriteTabs.includes('student-overview'),
                label: this.$tc('Student overview'),
                to: `/groups/${this.group ? this.group.id : ''}/student-list`,
                slug: 'student-overview',
            },
            {
                color: TabsColorEnum.DARK_GREEN,
                description: `${this.$tc('navigationCard.group.studentOverview')}`,
                icon: 'area_chart',
                is_visible: this.favouriteTabs.includes('student-overview-detailed'),
                label: this.$tc('navigationCard.group.titles.studentOverview'),
                to: `/groups/${this.group ? this.group.id : ''}/student-overview`,
                slug: 'student-overview-detailed',
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('navigationCard.group.curriculum')}`,
                icon: 'dynamic_feed',
                is_visible: this.favouriteTabs.includes('curriculum'),
                label: this.$tc('navigationCard.group.titles.curriculum'),
                to: `/groups/${this.group ? this.group.id : ''}/curriculum`,
                slug: 'curriculum',
            },
            {
                color: TabsColorEnum.BLUE,
                description: this.$tc('navigationCard.student.plan_group', 1),
                icon: 'receipt_long',
                label: this.$tc('student_plan.title_group', 1),
                is_visible: this.favouriteTabs.includes('student-plan'),
                to: `/groups/${this.group ? this.group.id : ''}/plan`,
                slug: 'student-plan',
            },
            {
                color: TabsColorEnum.YELLOW,
                description: `${this.$tc('navigationCard.group.notes')}`,
                icon: 'sticky_note_2',
                is_visible: this.favouriteTabs.includes('notes'),
                label: this.$tc('navigationCard.group.titles.notes'),
                to: `/groups/${this.group ? this.group.id : ''}/notes`,
                slug: 'notes',
            },
            {
                color: TabsColorEnum.PINK,
                description: `${this.$tc('navigationCard.group.report')}`,
                icon: 'description',
                is_visible: this.favouriteTabs.includes('report'),
                label: this.$tc('navigationCard.group.titles.report'),
                to: `/groups/${this.group ? this.group.id : ''}/report`,
                slug: 'report',
            },
            {
                color: TabsColorEnum.RED,
                description: `${this.$tc('navigationCard.group.files')}`,
                icon: 'article',
                is_visible: this.favouriteTabs.includes('files'),
                label: this.$tc('subject.tab.files'),
                to: `/groups/${this.group ? this.group.id : ''}/files`,
                slug: 'files',
            },
            {
                color: TabsColorEnum.PINK,
                description: `${this.$tc('navigationCard.group.steps')}`,
                icon: 'low_priority',
                is_visible: this.favouriteTabs.includes('steps'),
                label: this.$tc('steps.title'),
                to: `/groups/${this.group ? this.group.id : ''}/steps`,
                slug: 'steps',
            },
            {
                color: TabsColorEnum.PURPLE,
                description: `${this.$tc('navigationCard.group.messages')}`,
                icon: 'question_answer',
                is_visible: this.favouriteTabs.includes('messages'),
                label: this.$tc('navigationCard.group.titles.messages'),
                to: `/groups/${this.group ? this.group.id : ''}/messages`,
                slug: 'messages',
            },
            {
                color: TabsColorEnum.GREY,
                description: `${this.$tc('navigationCard.group.audit')}`,
                icon: 'approval',
                is_visible: this.favouriteTabs.includes('groups-audit'),
                label: 'GroepsAudit',
                to: `/groups/${this.group ? this.group.id : ''}/audit`,
                slug: 'groups-audit',
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: this.$tc('Here you can see the menu with all goal sets that are assigned to this group.'),
                icon: 'cases',
                is_visible: this.favouriteTabs.includes('assigned-projects'),
                label: this.$tc('Assigned projects'),
                to: `/groups/${this.group ? this.group.id : ''}/projects`,
                slug: 'assigned-projects',
            },
            {
                color: TabsColorEnum.RED,
                description: this.$tc('Here you can plan your daily or weekly goals.'),
                icon: 'event',
                is_visible: this.favouriteTabs.includes('period-planner'),
                label: this.$tc('Period planner'),
                to: `/groups/${this.group ? this.group.id : ''}/goal-planner`,
                slug: 'period-planner',
            },
        ];
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], FavoriteGroupItems.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], FavoriteGroupItems.prototype, "favouriteTabs", void 0);
FavoriteGroupItems = __decorate([
    Component({
        components: {
            NavigationCard,
        },
    })
], FavoriteGroupItems);
export default FavoriteGroupItems;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
